// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uib-datepicker-popup.dropdown-menu {\n  display: block;\n  float: none;\n  margin: 0;\n}\n\n.uib-button-bar {\n  padding: 10px 9px 2px;\n}\n", ""]);
// Exports
module.exports = exports;
